/**
 * 一个单例用于存储水印图片
 *
 * 生成水印图并存入localStorage
 * 以waterMarker做key，{erp: ..., value: base64}为值
 *
 * 如果登录，去取是否有erp对应，如果有并且erp对的上返回，否则清除
 *
 * 生成base64和erp一起存起来
 *
 * 生成的时机要选好，不能阻塞DOM
 *
 */
var watermarker: any = null;

interface ErpDataType {
  erp: string;
  value: string;
}

var objWatermarker = {
  remove() {
    try {
      localStorage.removeItem('watermark');
    } catch (ex) {
      console.error(ex);
    }
  },
  add(erp: string, value: string) {
    try {
      localStorage.setItem('watermark', JSON.stringify({ erp, value }));
    } catch (ex) {
      console.error(ex);
    }
  },
  get(erp: string) {
    if (!erp) return null;
    try {
      var item: string | null = localStorage.getItem('watermark');
      var itemData: ErpDataType = { erp: '', value: '' };
      if (item) {
        itemData = JSON.parse(item);
        if (itemData.erp === erp) {
          return itemData.value;
        } else {
          objWatermarker.remove();
        }
      }
    } catch (ex) {
      console.log(ex);
      return null;
    }

    return null;
  },
};

function generaterWatermarker(watermarkerString: any) {
  if (typeof watermarkerString !== 'string') throw new TypeError('waternarker不是string类型');

  var canvas = document.createElement('canvas');
  canvas.width = 300;
  canvas.height = 300;
  var ctx: any = canvas.getContext('2d');

  ctx.font = '12px serif';
  var info = ctx.measureText(watermarkerString);
  var w = info.width;
  ctx.textBaseline = 'middle';
  ctx.rotate((Math.PI * 1) / 4);
  ctx.translate((Math.sqrt(canvas.width * canvas.height + canvas.width * canvas.height) - w) / 2, 0);
  ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
  ctx.fillText(watermarkerString, 0, 0);

  return canvas.toDataURL('image/png');
}

function getWatermarker(erp: string) {
  if (watermarker) return watermarker;

  watermarker = objWatermarker.get(erp);

  if (watermarker) return watermarker;

  watermarker = generaterWatermarker(erp);

  objWatermarker.add(erp, watermarker);

  return watermarker;
}

export default getWatermarker;
